// extracted by mini-css-extract-plugin
export var container = "styles-module--container--82e54";
export var progressBar = "styles-module--progressBar--16c9a";
export var text = "styles-module--text--ea4b4";